import { VoteIcon } from './VoteIcon';

/**
 * author: Google
 * id 61CDB722-3238-4F21-9A3F-77DC47A51755
 * name vote
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vote.svg
 * tags
 */
export const HowToVoteIcon = VoteIcon;
export default HowToVoteIcon